module.exports = __webpack_public_path__ + "img/plan-notification.2e0cbbf5.svg";